import { substringiqarkczpya5m as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  isHighSurrogate11jfjw70ar0zf as isHighSurrogate,
  isLowSurrogateujxcv7hjn4ma as isLowSurrogate,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function utf8Size(_this__u8e3s4) {
  var size = 0;
  var index = 0;
  while (index < _this__u8e3s4.length) {
    var bytes = utf8ByteCountAt(_this__u8e3s4, index);
    size = size + bytes | 0;
    index = index + (bytes === 4 ? 2 : 1) | 0;
  }
  return size;
}
function utf8Truncate(_this__u8e3s4, maxSize) {
  var size = 0;
  var index = 0;
  $l$loop: while (index < _this__u8e3s4.length) {
    var bytes = utf8ByteCountAt(_this__u8e3s4, index);
    if ((size + bytes | 0) > maxSize)
      break $l$loop;
    size = size + bytes | 0;
    index = index + (bytes === 4 ? 2 : 1) | 0;
  }
  return index === _this__u8e3s4.length ? _this__u8e3s4 : substring(_this__u8e3s4, 0, index);
}
function utf8ByteCountAt(_this__u8e3s4, index) {
  // Inline function 'kotlin.code' call
  var this_0 = charCodeAt(_this__u8e3s4, index);
  var code = Char__toInt_impl_vasixd(this_0);
  return code < 128 ? 1 : code < 2048 ? 2 : isHighSurrogate(charCodeAt(_this__u8e3s4, index)) && (index + 1 | 0) < _this__u8e3s4.length && isLowSurrogate(charCodeAt(_this__u8e3s4, index + 1 | 0)) ? 4 : 3;
}
function validateSize(_this__u8e3s4) {
  // Inline function 'kotlin.require' call
  if (!(!_this__u8e3s4.e5e_1.b5e_1 || _this__u8e3s4.f5e_1.length <= 125)) {
    var message = 'Control frames must not exceed 125 bytes per RFC 6455, ' + ('but ' + _this__u8e3s4.e5e_1.toString() + ' frame has ' + _this__u8e3s4.f5e_1.length + ' bytes');
    throw IllegalArgumentException().o2(toString(message));
  }
}
//region block: exports
export {
  utf8Size as utf8Size2vilcxlxicj31,
  utf8Truncate as utf8Truncate258zdrrdcuqgj,
  validateSize as validateSize23lir9ygeqvey,
};
//endregion

//# sourceMappingURL=ControlFrames.mjs.map
